import moment from "moment";

const jobPostingSchema = job => {
  const postedDate = moment(job.updatedAt).format("DD-MM-YYYY");
  const validThrough = moment(job.updatedAt)
    .add(2, "M")
    .format("DD-MM-YYYY");
  return {
    "@context": "http://schema.org",
    "@type": "JobPosting",
    title: job.job_title,
    description: job.job_description,
    workHours: "40 hours per week",
    hiringOrganization: {
      "@type": "Organization",
      name: job.hiringOrganization,
      sameAs: "https://www.hirexl.in",
      logo: "https://www.hirexl.in/logo.png"
    },
    validThrough: validThrough,
    baseSalary: {
      "@type": "MonetaryAmount",
      currency: "INR",
      value: {
        "@type": "QuantitativeValue",
        value: job.max_salary,
        unitText: "YEAR"
      }
    },
    datePosted: postedDate,
    employmentType: job.job_category,
    experienceRequirements: `${job.min_experience}-${job.max_experience} Year`,
    industry: job.functional_area,
    jobLocation: {
      "@type": "Place",
      address: {
        "@type": "PostalAddress",
        addressCountry: "IN",
        addressRegion: "",
        addressLocality: job.job_location
      }
    },
    occupationalCategory: [job.functional_area],
    qualifications: "Graduation with reputed college",
    salaryCurrency: "INR",
    skills: job.functional_area
  };
};

const organizationSchema = () => {
  return {
    "@context": "http://schema.org",
    "@type": "Organization",
    location: {
      "@type": "Place",
      address:
        "336, Udyog Vihar Phase 4 Rd, Phase II, Udyog Vihar, Sector 20, Gurugram, Haryana 122022"
    },
    name: "HireXL",
    description:
      "HireXL - Academic Jobs Curriculum Designing Jobs Education Industry Jobs Edtech Jobs Teaching vacancies.",
    logo: "https://www.hirexl.in/logo.png",
    url: "https://www.hirexl.in",
    email: "support@hirexl.in"
  };
};

export { jobPostingSchema, organizationSchema };
